<template>
<div v-on:click="favoriteAction(id)" class="favoritemark">
	<span v-if="label" class="favoritemark__text">お気に入り</span> <i v-bind:class="{'icon2_favorite': fav, 'icon2_add_to_favorite': !fav}" class="favoritemark__icon" title="お気に入り"></i>
</div>
</template>

<script>
module.exports = {
	props: {
		id: {
			required: true
		},
		label: {
			type: Boolean
		},
		action: {
			type: Boolean,
			required: true
		}
	},
	data: function(){
		return {
			fav: ''
		};
	},
	ready: function(){
		// set fav
		this.$watch(function(){
			if (this.id){
				this.toggleFav(this.id);
			}
		});
	},
	methods: {
		toggleFav: function(id){
			var my_id = encodeURIComponent(',' + id);
			var match_my_id = new RegExp(my_id, 'g');
			var cr_v = String(window.localStorage.getItem('fav'));

			if (cr_v.match(match_my_id) !== null){
				// matching
				this.fav = true;
			} else {
				// no matching
				this.fav = false;
			}
		},
		favoriteAction: function(id){
			// get my id & get localStorage value
			var my_id = encodeURIComponent(',' + id);
			var match_my_id = new RegExp(my_id, 'g');
			var cr_v = String(window.localStorage.getItem('fav'));

			if (cr_v.match(match_my_id) !== null){
				// matching, remove favorite action
				this.fav = false;
				var remove_v = cr_v.replace(match_my_id, '');
				window.localStorage.setItem('fav', remove_v);
			} else {
				// no matching, add favorite action
				this.fav = true;
				var add_v = cr_v + my_id;
				window.localStorage.setItem('fav', add_v);
			}

			if (this.action){
				this.$dispatch('deliverFavAction', id);
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// favorite_action.vue?baa5d9cc